import { ReactNode, useState } from "react";
import { ISPContext, ISPMutatorContext } from "./ispContexts";

interface IProps {
  children: ReactNode;
}

const IspContextProvider = (props: IProps) => {
  const [ispName, setIspName] = useState<string | null>(null);

  return (
    <ISPMutatorContext.Provider value={setIspName}>
      <ISPContext.Provider value={ispName}>{props.children}</ISPContext.Provider>
    </ISPMutatorContext.Provider>
  );
};

export default IspContextProvider;
